import type {
	NullableOption,
	IssueLinkDirection,
} from '@jira/issue-field-link-relationship-editview-full/src/types.tsx';

const capitalize = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const createSelectedOptionFromFieldData = (issueLinkData: {
	issueLinkTypeARI: string;
	relationName: string;
	direction: IssueLinkDirection;
}): NullableOption => {
	const { issueLinkTypeARI, relationName, direction } = issueLinkData || {};

	if (!issueLinkTypeARI || !relationName || !direction) return null;

	return {
		id: `${issueLinkTypeARI}_${direction}`,
		value: issueLinkTypeARI,
		label: capitalize(relationName),
		direction,
	};
};
